export const setIsloading = (payload) => {
  return (dispatch) => {
    dispatch({type: 'SET_IS_LOADING', payload});
  };
};
